import typeOptions from './typeOptions';
import deviceTypeOptions, { pcSubOptions, allOptions } from './deviceTypeOptions';

const PermissionContentMap = {};

// Initialize with typeOptions (Video/App types)
if (Array.isArray(typeOptions)) {
    typeOptions.forEach(option => {
        PermissionContentMap[option.value] = option.label;
    });
}

// Initialize with deviceTypeOptions (PC, VR, Launcher, Master)
if (Array.isArray(deviceTypeOptions)) {
    deviceTypeOptions.forEach(option => {
        PermissionContentMap[option.value] = option.label;
    });
}

// Initialize with allOptions (PC Sub-options mappings like '0': 'PC - ACER')
if (allOptions) {
    Object.entries(allOptions).forEach(([key, value]) => {
        PermissionContentMap[key] = value.label;
    });
}

/**
 * Get the display label for a permission type.
 * Handles single values, comma-separated values, and PC specifically.
 * @param {string} type - The permission type string (e.g., 'V_HD', '0', 'PC', '0,1')
 * @returns {string} The formatted label
 */
export const getPermissionLabel = (type) => {
    if (!type) return '';

    // Handle comma-separated values
    if (type.includes(',')) {
        const types = type.split(',');

        // Special handling for PC sub-types
        const isAllPcSub = types.every(t => ['0', '1', '2'].includes(t));

        if (isAllPcSub) {
            const pcLabels = types.map(t => {
                const subOpt = pcSubOptions.find(opt => opt.value === t);
                return subOpt ? subOpt.label : t;
            });
            return `PC (${pcLabels.join(', ')})`;
        }

        // Default join for other mixed types
        const labels = types.map(t => PermissionContentMap[t] || t);
        return labels.join(', ');
    }

    return PermissionContentMap[type] || type;
};

export default PermissionContentMap;
